import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import '../css/Tooltip.css';

const Tooltip = ({ children, content, imageUrl, className = '' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState('bottom');
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const tooltipRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    if (isVisible && tooltipRef.current && triggerRef.current) {
      const trigger = triggerRef.current;
      const rect = trigger.getBoundingClientRect();
      const tooltip = tooltipRef.current;
      const tooltipRect = tooltip.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      let top, left;
      if (spaceBelow >= tooltipRect.height + 10 || spaceBelow > spaceAbove) {
        setPosition('bottom');
        top = rect.bottom + 5;
      } else {
        setPosition('top');
        top = rect.top - tooltipRect.height - 5;
      }
      left = rect.left + rect.width / 2 - tooltipRect.width / 2;
      // Spriječi izlazak izvan ekrana
      left = Math.max(8, Math.min(left, window.innerWidth - tooltipRect.width - 8));
      setCoords({ top, left });
    }
  }, [isVisible]);

  // Ako nema sadržaja ni slike, ne prikazuj tooltip
  if (!content && !imageUrl) {
    return <span ref={triggerRef}>{children}</span>;
  }

  return (
    <span
      className={`tooltip-trigger ${className}`}
      ref={triggerRef}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (content || imageUrl) && ReactDOM.createPortal(
        <div
          ref={tooltipRef}
          className={`tooltip tooltip-${position}`}
          style={{
            top: coords.top,
            left: coords.left,
            position: 'fixed',
            zIndex: 99999,
            pointerEvents: 'none',
          }}
        >
          {imageUrl && (
            <div style={{ marginBottom: content ? '8px' : '0' }}>
              <img 
                src={imageUrl} 
                alt="Osoba" 
                style={{ 
                  maxWidth: '200px', 
                  maxHeight: '200px', 
                  borderRadius: '4px',
                  display: 'block'
                }} 
              />
            </div>
          )}
          {content && (
            <div style={{ whiteSpace: 'pre-wrap' }}>{content}</div>
          )}
        </div>,
        document.body
      )}
    </span>
  );
};

export default Tooltip; 